module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-05-5b22230a9a7c2f3958dc7f92b204e81e.png";